const o = {
  id: "PuertoRicoLotoCash",
  logo: !0,
  name: "Loto Cash",
  style: {
    colorPrimary: "#007d27",
    extraBall: {
      bg: "#007d27",
      color: "#ffffff"
    }
  }
};
export {
  o as default
};
